export default function limitNumber (n, min, max) {
  return Math.min(Math.max(n, min), max)
}
